import { render, staticRenderFns } from "./reportProblem.vue?vue&type=template&id=32c460a7&scoped=true"
import script from "./reportProblem.vue?vue&type=script&lang=js"
export * from "./reportProblem.vue?vue&type=script&lang=js"
import style0 from "./reportProblem.vue?vue&type=style&index=0&id=32c460a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c460a7",
  null
  
)

export default component.exports